"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLayout = MobileLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = require("../pages/layout/navigation");
const BottomBarMobile_1 = require("../components/mobile-view/nav-bar/BottomBarMobile");
const AuthContext_1 = require("../hooks/auth/context/AuthContext");
function MobileLayout() {
    const { userInfo } = (0, AuthContext_1.useAuth)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'min-h-screen', style: { backgroundColor: '#f5f7fa' }, children: [(0, jsx_runtime_1.jsx)(navigation_1.NavigationMobileComponent, {}), (0, jsx_runtime_1.jsx)("main", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }), (0, jsx_runtime_1.jsx)(BottomBarMobile_1.MobileBottomBar, { username: userInfo?.username || '', homeRoute: "/", profileRoute: "/mobile/profile" })] }));
}
